import { permissionValue } from '../../enums/permissionValue'

interface OnEquipment {
  mainComponentId?: number | null
}

const adminBits = [permissionValue.ClientAdminPermission, permissionValue.SystemAdminPermission]

const holds = (permission: number, bit: number) => (BigInt(permission) & BigInt(bit)) === BigInt(bit)

export const canMoveDeviation = (permission: number | undefined, deviation: OnEquipment): boolean =>
  permission !== undefined &&
  permission > 0 &&
  typeof deviation.mainComponentId === 'number' &&
  adminBits.some(bit => holds(permission, bit))

export const moveTargetFor = (deviation: OnEquipment, selectedEquipmentId?: number | null): number | null =>
  selectedEquipmentId == null || selectedEquipmentId === deviation.mainComponentId ? null : selectedEquipmentId

export interface SaveDeviationDeps<F> {
  move: (equipmentId: number) => Promise<unknown>
  update: (form: F) => Promise<unknown>
}

export const saveDeviation = async <F>(deps: SaveDeviationDeps<F>, target: number | null, form: F): Promise<void> => {
  if (target !== null) {
    await deps.move(target)
  }
  await deps.update(form)
}

const refusalKeys: unknown[] = [
  'DeviationMoveNotAdmin',
  'DeviationNotFound',
  'DeviationNotOnEquipment',
  'DeviationLinkedCannotMove',
  'DeviationMoveTargetNotFound',
]

export const moveRefusalKey = (error: { status?: number; data?: unknown } | undefined): string =>
  refusalKeys.includes(error?.data) ? (error?.data as string) : 'unExpectedError'

export const saveDeviationFailureKey = async <F>(
  deps: SaveDeviationDeps<F>,
  target: number | null,
  form: F,
): Promise<string | null> => {
  let moved = false
  const move = async (equipmentId: number) => {
    await deps.move(equipmentId)
    moved = true
  }
  try {
    await saveDeviation({ move, update: deps.update }, target, form)
    return null
  } catch (error) {
    return moved ? 'DeviationMovedNotUpdated' : moveRefusalKey(error as { status?: number; data?: unknown })
  }
}

type Id = number | string

export interface DeviationMove {
  customerId: Id
  deviationId: Id
  fromEquipmentId: Id
  toEquipmentId: Id
}

export const queriesToRefreshAfterMove = ({
  customerId,
  deviationId,
  fromEquipmentId,
  toEquipmentId,
}: DeviationMove): string[][] => {
  const [c, d, from, to] = [customerId, deviationId, fromEquipmentId, toEquipmentId].map(String)
  return [
    ['deviation', c, d],
    ['deviations', c],
    ['mainComponentById', c, from],
    ['mainComponentById', c, to],
    ['get-activity-logs', from],
    ['get-activity-logs', to],
  ]
}
